interface Entity {
  [species: string]: {
    position: number[],
    content: number[][]
  }
}

// for many entities, see this catalog:
// http://www.ericweisstein.com/encyclopedias/life
// http://pentadecathlon.com/lifeNews/oscillators/
// https://www.conwaylife.com/wiki/Main_Page
// https://www.conwaylife.com/wiki/Category:Oscillators
export const species: Entity = {
  glider: {
    position: [25,25],
    content: [
      [0,1,1,1],
      [0,1,0,0],
      [0,0,1,0],
  ]
},
  pulsar: {
    position: [20,20],
    content: [
      [0,0,1,1,1,0,0,0,1,1,1,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [1,0,0,0,0,1,0,1,0,0,0,0,1],
      [1,0,0,0,0,1,0,1,0,0,0,0,1],
      [1,0,0,0,0,1,0,1,0,0,0,0,1],
      [0,0,1,1,1,0,0,0,1,1,1,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,1,1,1,0,0,0,1,1,1,0,0],
      [1,0,0,0,0,1,0,1,0,0,0,0,1],
      [1,0,0,0,0,1,0,1,0,0,0,0,1],
      [1,0,0,0,0,1,0,1,0,0,0,0,1],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,1,1,1,0,0,0,1,1,1,0,0],
    ]
  },
  pentadecathlon: {
    position: [20,25],
    content:[
      [0,1,0],
      [0,1,0],
      [1,0,1],
      [0,1,0],
      [0,1,0],
      [0,1,0],
      [0,1,0],
      [1,0,1],
      [0,1,0],
      [0,1,0],
    ]
  },
  fumarol: {
    position: [20,20],
    content:[
      [0,0,0,1,1,0,0,0],
      [0,1,0,0,0,0,1,0],
      [0,1,0,0,0,0,1,0],
      [0,1,0,0,0,0,1,0],
      [0,0,1,0,0,1,0,0],
      [1,0,1,0,0,1,0,1],
      [1,1,0,0,0,0,1,1],
    ]
  },
  ant: {
    position: [10,10],
    content: [
      [0,1,1,0,0,0,0,0,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0],
      [0,0,0,1,1,0,1,1,0,0,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1],
      [0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1],
      [0,1,1,0,0,0,0,0,1,1,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0],
      [0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    ]
  },
  "PI-heptomino": {
    position: [10,10],
    content: [
      [0,1,1,1],
      [0,1,0,1],
      [0,1,0,1],
    ]
  },
  cross: {
    position: [10,10],
    content: [
      [0,0,1,1,1,1,0,0],
      [0,0,1,0,0,1,0,0],
      [1,1,1,0,0,1,1,1],
      [1,0,0,0,0,0,0,1],
      [1,0,0,0,0,0,0,1],
      [1,1,1,0,0,1,1,1],
      [0,0,1,0,0,1,0,0],
      [0,0,1,1,1,1,0,0],
    ]
  },
  cross2: {
    position: [20, 20],
    content: [
      [0,0,0,1,0,0,1,0,1,0,0,1,0,0,0],
      [0,0,0,1,0,0,1,0,1,0,0,1,0,0,0],
      [0,0,1,1,0,0,1,0,1,0,0,1,1,0,0],
      [1,1,1,0,0,0,0,1,0,0,0,0,1,1,1],
      [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [1,1,1,0,0,0,0,0,0,0,0,0,1,1,1],
      [0,0,0,1,1,0,0,0,0,0,1,1,0,0,0],
      [1,1,1,0,0,0,0,0,0,0,0,0,1,1,1],
      [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0],
      [1,1,1,0,0,0,0,1,0,0,0,0,1,1,1],
      [0,0,1,1,0,0,1,0,1,0,0,1,1,0,0],
      [0,0,0,1,0,0,1,0,1,0,0,1,0,0,0],
      [0,0,0,1,0,0,1,0,1,0,0,1,0,0,0],
    ]
  },
  "bent keys": {
    position: [10,10],
    content: [
      [0,1,0,0,0,0,0,0,0,0,1,0],
      [1,0,1,0,0,0,0,0,0,1,0,1],
      [0,1,0,1,1,0,0,1,1,0,1,0],
      [0,0,0,0,1,0,0,1,0,0,0,0],
      [0,0,0,0,1,0,0,1,0,0,0,0],
    ]
  },
  decapole: {
    position: [10,10],
    content: [
      [0,0,0,0,0,0,0,0,0,0,0,1,1],
      [0,0,0,0,0,0,0,0,0,0,1,0,1],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,1,0,1,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,1,0,1,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,1,0,1,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [0,0,1,0,1,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0,0,0],
      [1,0,1,0,0,0,0,0,0,0,0,0,0],
      [1,1,0,0,0,0,0,0,0,0,0,0,0],
    ]
  },
  clock: {
    position: [10,10],
    content: [
      [0,0,1,0],
      [1,0,1,0],
      [0,1,0,1],
      [0,1,0,0],
    ]
  },
  smiley: {
    position: [10,10],
    content: [
      [1,1,1,0,1,1,1],
      [0,1,0,1,0,1,0],
      [0,0,0,0,0,0,0],
      [0,1,0,0,0,1,0],
      [0,0,0,0,0,0,0],
      [1,0,1,0,1,0,1],
      [0,0,1,0,1,0,0],
    ]
  },
  star: {
    position: [20,20],
    content: [
      [0,0,0,0,1,1,1,0,0,0,0],
      [0,0,0,0,0,0,0,0,0,0,0],
      [0,0,1,0,1,0,1,0,1,0,0],
      [0,0,0,0,0,0,0,0,0,0,0],
      [1,0,1,0,0,0,0,0,1,0,1],
      [1,0,0,0,0,0,0,0,0,0,1],
      [1,0,1,0,0,0,0,0,1,0,1],
      [0,0,0,0,0,0,0,0,0,0,0],
      [0,0,1,0,1,0,1,0,1,0,0],
      [0,0,0,0,0,0,0,0,0,0,0],
      [0,0,0,0,1,1,1,0,0,0,0],
    ]
  },
  canadagoose: {
    position: [20, 20],
    content: [
      [1,1,1,0,0,0,0,0,0,0,0,0,0],
      [1,0,0,0,0,0,0,0,0,0,1,1,0],
      [0,1,0,0,0,0,0,0,1,1,1,0,1],
      [0,0,0,1,1,0,0,1,1,0,0,0,0],
      [0,0,0,0,1,0,0,0,0,0,0,0,0],
      [0,0,0,0,0,0,0,0,1,0,0,0,0],
      [0,0,0,0,1,1,0,0,0,1,0,0,0],
      [0,0,0,1,0,1,0,1,1,0,0,0,0],
      [0,0,0,1,0,1,0,0,1,0,1,1,0],
      [0,0,1,0,0,0,0,1,1,0,0,0,0],
      [0,0,1,1,0,0,0,0,0,0,0,0,0],
      [0,0,1,1,0,0,0,0,0,0,0,0,0],
    ]
  }
}
